// ═══════════════════════════════════════════════════════════
// Strategy Constants — Fallback defaults for condition builder
// Live values are served from backend API: GET /api/config/strategy-options
// This file is used as default until API responds or if API fails.
// ═══════════════════════════════════════════════════════════

export const TIMEFRAME_OPTIONS = [
  // Only 1m and 5m have a live data path right now (the engine's
  // TIMEFRAME_MAP is restricted to these). Higher timeframes are
  // re-enabled here once their live OHLC + feature tables exist.
  { value: '1m', label: '1 Min' },
  { value: '5m', label: '5 Min' },
  // { value: '10m', label: '10 Min' },
  // { value: '15m', label: '15 Min' },
  // { value: '1h', label: '1 Hour' },
];

export const ACTION_OPTIONS = ['BUY', 'SELL'];

export const MODE_OPTIONS = [
  { value: 'Signal', label: 'Signal' },
  { value: 'Notification', label: 'Notification' },
  { value: 'Trade', label: 'Trade' },
];

// Price and Volume are hidden until the engine maps them to real data
// (VARIABLE_TO_COLUMN on the backend currently supports only the SMA
// columns). Offering them would let users save strategies that can
// never fire. Re-add when backend support lands.
export const CATEGORY_OPTIONS = ['Technical Indicator', 'Time'];

export const VARIABLE_OPTIONS = {
  'Technical Indicator': [
    'SMA (10)', 'SMA (20)',
    // Future indicators — uncomment when co-developer adds DB columns:
    // 'RSI (14)', 'SMA (50)', 'EMA (20)',
    // 'MACD (12,26,9)', 'MACD Signal', 'MACD Histogram',
    // 'Bollinger Upper', 'Bollinger Middle', 'Bollinger Lower', 'ATR (14)',
  ],
  // 'Price': ['Price (LTP)'],   // pending engine support
  // 'Volume': ['Volume'],       // pending engine support
  'Time': ['Market Time'],
};

export const ALL_INDICATORS = [
  'SMA (10)', 'SMA (20)',
  // Future indicators — uncomment when co-developer adds DB columns:
  // 'RSI (14)', 'SMA (50)', 'EMA (20)',
  // 'MACD (12,26,9)', 'MACD Signal', 'MACD Histogram',
  // 'Bollinger Upper', 'Bollinger Middle', 'Bollinger Lower',
  // 'ATR (14)', 'Price (LTP)', 'Volume',
];

export const OPERATOR_OPTIONS = [
  { value: 'Is Greater Than',             label: '＞\u2002\u2002Greater Than' },
  { value: 'Is Less Than',                label: '＜\u2002\u2002Less Than' },
  { value: 'Is Greater Than Or Equal To', label: '≥\u2002\u2002Greater Or Equal' },
  { value: 'Is Less Than Or Equal To',    label: '≤\u2002\u2002Less Or Equal' },
  { value: 'Crosses Above',               label: '↗\u2002\u2002Crosses Above' },
  { value: 'Crosses Below',               label: '↘\u2002\u2002Crosses Below' },
  { value: 'Equals',                      label: '＝\u2002\u2002Equals' },
];

export const TIME_OPERATOR_OPTIONS = [
  { value: 'Is After',       label: '＞\u2002\u2002After' },
  { value: 'Is Before',      label: '＜\u2002\u2002Before' },
  { value: 'Is At Or After', label: '≥\u2002\u2002At Or After' },
  { value: 'Is At Or Before',label: '≤\u2002\u2002At Or Before' },
];
